import { AcademicPageHeader } from "@/components/records/AcademicWorkspace";
import { DashboardNotice } from "@/components/dashboard/DashboardNotice";
import { RegistrarOverview } from "@/components/dashboard/RegistrarOverview";
import { useAuth } from "@/contexts/AuthContext";
import { useAdminDashboard } from "@/hooks/use-dashboard";
import { ApiError } from "@/lib/api/client";
import { firstName, greetingSuffix } from "@/lib/greeting";
import { loadState } from "@/lib/query-state";

/** The registrar's read sections retain their boxes through empty and failed reads. */
export function AdminDashboardPage() {
  const { me } = useAuth();
  const query = useAdminDashboard();
  const authorityRefused = query.error instanceof ApiError && (query.error.status === 401 || query.error.status === 403);
  const data = authorityRefused ? undefined : query.data;
  const state = authorityRefused ? "error" : loadState(query);
  const greeting = greetingSuffix(null, me?.preferred_name, firstName(me?.full_name));
  return <div className="app-page" data-seat-home-widgets>
    <AcademicPageHeader eyebrow="Overview" title={`Welcome${greeting}.`} description="Institutional records and scheduled sessions at a glance." />
    {!data && state === "error" ? <DashboardNotice perspective="registrar" state="error" onRetry={() => void query.refetch()} />
      : <RegistrarOverview data={data} stale={query.isError} retry={() => void query.refetch()} />}
  </div>;
}
